import * as _ from 'lodash';
import { IPositionCoordinator } from '@nkr/models/position-coordinator';
import { SwapGridWrapper } from '../styles';

interface IProps {
    coordinators: IPositionCoordinator[],
    sidebar?: boolean
}

const Coordinators = (props: IProps) => {
    const sortedCoordinators = _.sortBy(props.coordinators, x => x.position);

    return (
        <SwapGridWrapper condensed bordered style={{ fontSize: props.sidebar ? 12 : null }}>
            <thead>
                <tr>
                    <th rowSpan={2}>
                        Position
                    </th>
                    <th colSpan={3}>Assigned Donor Coordinator
                    </th>
                    <th colSpan={3}>Assigned Recipient Coordinator
                    </th>
                </tr>
                <tr>
                    <th>
                        Center
                    </th>
                    <th>
                        Name
                    </th>
                    <th>
                        Phone
                    </th>

                    <th>
                        Center
                    </th>
                    <th>
                        Name
                    </th>
                    <th>
                        Phone
                    </th>
                </tr>
            </thead>
            <tbody>
                {sortedCoordinators.map(item =>
                    <tr>
                        <td>{item.position}</td>
                        <td>{item.donorCoordinator.centerAlias}</td>
                        <td><a href={'mailto: ' + item.donorCoordinator.email}>{item.donorCoordinator.fullName}</a></td>
                        <td>{item.donorCoordinator.phoneNumber}</td>

                        <td>{item.recipientCoordinator.centerAlias}</td>
                        <td><a href={'mailto: ' + item.recipientCoordinator.email}>{item.recipientCoordinator.fullName}</a></td>
                        <td>{item.recipientCoordinator.phoneNumber}</td>
                    </tr>
                )}
            </tbody>
        </SwapGridWrapper>
    )
}

export default Coordinators;